import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { trackFlightBannerClick, trackFlightBannerShow } from './tracking';
import { FlightBannerDesktop } from '../../components/FlightBanner/desktop';
import { FlightBannerMobile } from '../../components/FlightBanner/mobile';
import { FLIGHT_BANNER_URL_CONFIG_KEY } from '../../constants/config';
import { useApplicationContext } from '../../utils/applicationContext';

// TODO: Удалить в CD-220902.
export const FlightBannerContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const url = config.get<string>(FLIGHT_BANNER_URL_CONFIG_KEY);

  if (!url) {
    return null;
  }

  return (
    <>
      <Responsive desktop>
        <FlightBannerDesktop url={url} onClick={trackFlightBannerClick} onShow={trackFlightBannerShow} />
      </Responsive>
      <Responsive tablet phone>
        <FlightBannerMobile url={url} onClick={trackFlightBannerClick} onShow={trackFlightBannerShow} />
      </Responsive>
    </>
  );
};
